import "./style.scss";

import NorthEastIcon from "@mui/icons-material/NorthEast";
import { useTranslation } from "react-i18next";

import googleSheetLogo from "../../../../../assets/img/png/google-sheet-logo.png";

/**
 * Google Sheet recap, on click navigate to the googlesheet
 */
interface ISheetRecap {
    spreadsheetName?: string;
    sheetName?: string;
    templateName?: string | undefined;
    onGoogleSheetNavigate: () => void;
    mode: "edit" | "new";
}

const SheetRecapBtn = ({ spreadsheetName, sheetName, onGoogleSheetNavigate, mode, templateName }: ISheetRecap) => {
    const [t] = useTranslation();

    return (
        <div
            className="selected-sheet-recap"
            title={t("PartnerStatements.SheetNavigate")}
            onClick={onGoogleSheetNavigate}
        >
            <img src={googleSheetLogo} className="google-sheet-logo" />
            <div className="selected-sheet-recap-body">
                <div className="selected-sheet-recap-body-text">
                    {mode === "new" && (
                        <>
                            <span className="spreadsheet-name">{spreadsheetName}</span>
                            <span className="sheet-name">{`<> ${sheetName}`}</span>
                        </>
                    )}
                    {mode === "edit" && <span className="spreadsheet-name">{templateName}</span>}
                </div>
                <div className="sheet-recap-right">
                    {mode === "edit" && <span>{t("PartnerStatements.ViewTemplate")}</span>}
                    <NorthEastIcon className="nav-to-sheet-icon" />
                </div>
            </div>
        </div>
    );
};

export default SheetRecapBtn;
